export default String.raw`
.category-description{
    &__title-container{
        margin: 25px;
    }
    &__container .description-container{
        padding: 25px;
    }
}
`